import { Handle, Position } from '@xyflow/react'
import '@xyflow/react/dist/style.css'
import styles from "./nodes.module.css"

const Start = ({ data, selected, dragging, className }) => {
    return (
        <div className={`${styles.node} ${styles.start} ${selected ? styles.selected : ''} ${dragging ? styles.dragging : ''} ${className}`}>
            <span>{data.label}</span>
            <Handle type="source" position={Position.Bottom} />
        </div>
    )
}

export default Start